/**
 * The base configuration for the VP app. This is the configuration that will most likely remain the same for all builds.
 */
const config = {
  /**
   * Custom header name in which the schema is sent
   */
  schemaHeaderName: 'X-SCHEMA',

  /**
   * The auth token name which is used as the key value when persisting the session token
   */
  authTokenName: 'ipro_session_token',

  privacyPolicyLink: 'https://www.ipro.net/privacy-policy ',
  termsAndConditionsLink: 'https://www.ipro.net/terms-and-conditions',
  contactSupportLink: 'https://www.ipro.net/contact/',
  iproLink: 'https://www.ipro.net/',
  knowledgeBaseLink: 'https://help.ipro.net/',
};

module.exports = config;
